import { render, staticRenderFns } from "./StarterPackChannelGateModal.vue?vue&type=template&id=4ae61dd0&scoped=true"
import script from "./StarterPackChannelGateModal.vue?vue&type=script&lang=js"
export * from "./StarterPackChannelGateModal.vue?vue&type=script&lang=js"
import style0 from "./StarterPackChannelGateModal.vue?vue&type=style&index=0&id=4ae61dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae61dd0",
  null
  
)

export default component.exports